
import { mapActions, mapMutations, mapState, Store } from 'vuex'
import Previewer from 'vux/src/components/previewer/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import bCard from 'bootstrap-vue/es/components/card/card'
import bTabs from 'bootstrap-vue/es/components/tabs/tabs'
import bTab from 'bootstrap-vue/es/components/tabs/tab'
import url from 'url'
import _ from 'lodash'
import moment from 'moment'
import imgSrc from '../assets/javascripts/imgSrc'
import canvas from '../assets/javascripts/canvas'
import bone from '../assets/javascripts/bone'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import { posture} from "../assets/lang.conf/root";
import Posture_symp from './Posture_symp'
import Posture_front from './Posture_front'
import Posture_flank from './Posture_flank'
import Posture_home from './Posture_home'
import Posture_report from './Posture_report'
import Symp_item from './Symp_item'
import Posture_modal from './Posture_modal'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import wx from 'weixin-js-sdk'
import Qrcode from "vux/src/components/qrcode/index";
window.cur_index=0;
let bullets = [
{
text: '首页',
bulletClassName: 'pagination-bullet font-12',
containerClassName: 'hidden-pagination',
iconClassName: ''
},
{
text: '体态数据',
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-face'
},
{
text: '风险评估',
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-riskassess'
},
{
text: '肌肉状态',
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-bone'
},






]
let viwesNav = [
{
text: '正面',
bulletClassName: 'pagination-bullet view-flant',
containerClassName: '',
iconClassName: 'pagination-icon pagination-views'
},
{
text: '侧面',
bulletClassName: 'pagination-bullet view-side',
containerClassName: '',
iconClassName: 'pagination-icon pagination-views'
}
];

export default {
name: 'posture',
i18n: { // `i18n` option, setup locale info for component
messages: {
...posture
}
},
directive: {
bModalDirective
},
components: {
Qrcode,
swiper,
swiperSlide,
Previewer,
Loading,
bModal,
bTabs,
bTab,
bCard,
Posture_symp,
Posture_front,
Posture_flank,
Posture_home,
Posture_report,
Symp_item,
Posture_modal,
},
data () {
return {
bullets: [
{
text: this.$t('bullet.home'),
bulletClassName: 'pagination-bullet font-12',
containerClassName: 'hidden-pagination',
iconClassName: ''
},
{
text: this.$t('bullet.Posturedata'),
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-face'
},
{
text: this.$t('bullet.Score'),
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-riskassess'
},
{
text: this.$t('bullet.Muscle'),
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-bone'
},
{
text: this.$t('bullet.Solution'),
bulletClassName: 'pagination-bullet font-12',
containerClassName: '',
iconClassName: 'pagination-icon pagination-symptom'
}
],
viwesNav: [
{
text: this.$tc('viwesNav', 0),
bulletClassName: 'pagination-bullet view-flant',
containerClassName: '',
iconClassName: 'pagination-icon pagination-views'
},
{
text: this.$tc('viwesNav', 1),
bulletClassName: 'pagination-bullet view-side',
containerClassName: '',
iconClassName: 'pagination-icon pagination-views'
}
],
isUpdate:false,
shelter:false,
valid: true,
loading: true,
updateSwiper: false,
containerSwiper:0,
qrCode:false,
reportData: {},
last_nav:false,
touchJump:false,
appopen:false,
customer: {},
viewIndex:1,
swiperOption: {
allowTouchMove:false,
pagination: {
el: '.posture-swiper-pagination',
clickable: true,
renderBullet (index, className) {
let display=""
console.log(bullets[index].containerClassName)
return `<div style="`+display+`" v-on:click="drawBone(`+index+`)" class="content-row content-row-column content-align-center content-row-around ${bullets[index].containerClassName} ${className}">` +
`<div class="${bullets[index].iconClassName}"></div>` +
`<span class="${bullets[index].bulletClassName}">${bullets[index].text}</span>` +
`</div>`
}
},
on: {

init () {
document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;

},
transitionEnd:function(event){


},
transitionStart:()=>{



},

slidePrevTransitionStart:function(){

this.activeIndex == 0 ? document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0 : '';


},
sliderMove:(event)=>{

/*  let x = sessionStorage.getItem("x");
let y = sessionStorage.getItem("y");

let newX = event.touches[0].pageX;
let newY = event.touches[0].pageY;
let containerSwiper = sessionStorage.getItem("containerSwiper");

sessionStorage.setItem('dis','-1' )
if((containerSwiper ==3 ) &&(x - newX > 10)){
this.touchJump=true;
sessionStorage.setItem('dis',x - newX )
}else{
this.touchJump = false;
}
*/

},
touchEnd:()=>{
this.start();
/*  let dis = sessionStorage.getItem("dis");
let containerSwiper = sessionStorage.getItem("containerSwiper");
if((containerSwiper ==3 ) && (dis > 0)) {
this.getSolutions();
} */
},
touchStart:(event)=>{
/*  this.stop();
let containerSwiper = sessionStorage.getItem("containerSwiper");
let x = event.touches[0].pageX;
let y = event.touches[0].pageY;

this.touchJump=false;
sessionStorage.setItem('x', x)
sessionStorage.setItem('y', y)


if(containerSwiper == 4){
this.getSolutions();
} */
},

slideChangeTransitionStart:function(){


sessionStorage.setItem('cur_index', this.activeIndex)
sessionStorage.setItem('containerSwiper', this.activeIndex)
},
slideChangeTransitionEnd:()=>{
this.containerSwiper = sessionStorage.getItem("containerSwiper");
},
tap:function(){

},
click:()=>{
let cur_index = sessionStorage.getItem("cur_index")
let jumpTime = sessionStorage.getItem("jumpTime");
sessionStorage.setItem('containerSwiper', cur_index)
this.containerSwiper = cur_index

this.touchJump=false;

/*  this.$refs.postureSwiper.swiper.allowSlideNext=true;
if(cur_index == 3){
this.$refs.postureSwiper.swiper.allowSlideNext=false;
} */


},
slideChange:(index) => {
let cur_index = sessionStorage.getItem("cur_index")


if (this.activeIndex === 0) {


document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0
} else {
/* if(this.isWechat){
this.showMini = true;
}else{
this.showMini = false;
} */
document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1
}
if ((cur_index == 2) || (cur_index == 4) || (cur_index == 1)) {
this.updateSwiper = true;
}
/* if(cur_index == 1 ){
if(this.isWechat){
this.showMini = false;
}

} */
}
}
},
swiperOptionview: {
allowTouchMove: true,
autoplay:false,
pagination: {
el: '.postureView-swiper-pagination',
clickable: true,
renderBullet (index, className) {

return `<div  style="width:100px;"  class="content-row content-row-column content-align-center `+'views'+index+` content-row-around ${viwesNav[index].containerClassName} ${className}">` +
`<div style = "height:2px;"></div>` +
`<span style="position:absolute" class="${viwesNav[index].bulletClassName}">${viwesNav[index].text}</span>` +
`<div style="height: 0.14rem;" class="${viwesNav[index].iconClassName}"></div>` +
`</div>`
}
},
on: {
init () {

},
allowSlidePrev:function(){

},
transitionEnd:function(event){


},
transitionStart:function(){



},
slidePrevTransitionStart:function(){





},
touchStart:function(){
/*  ////console.log("touchStart:",this.activeIndex)
let touchIndex = this.activeIndex;
sessionStorage.setItem('view', this.activeIndex) : '' */
sessionStorage.setItem('views_index', this.activeIndex)


},
touchEnd:() =>{
let viewsIndex = sessionStorage.getItem('views_index')
this.viewsIndex = viewsIndex;
},
slideNextTransitionStart:() => {
},
slideChangeTransitionStart:function(){


},
click:function(){

},
slideChange:(index) => {
/*  let cur_index = sessionStorage.getItem("cur_index")

if (this.activeIndex === 0) {
this.showMini = false;

document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0
} else {
if(this.isWechat){
this.showMini = true;
}else{
this.showMini = false;
}
document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1
}
if ((cur_index == 2) || (cur_index == 4) || (cur_index == 1)) {
this.updateSwiper = true;
}
if(cur_index == 1 ){
if(this.isWechat){
this.showMini = false;
}

} */
}
}
},
normalRisks: [],
mildRisks: [],
severeRisks: [],
symptoms: {
head: [
{
name: '头部侧倾',
key: 'headSidesway',
normal: {
left:imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
},
abnormal: {
left:imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
} ,
definition: '在直立过程中，头部向左或右倾斜的现象。',
harm: {
bone: '颈椎侧屈',
muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
},
risks: [
{
name: '肌肉韧带慢性劳损',
des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
},
{
name: '颈椎病',
des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
}
]
},
{
name: '头部前倾',
key: 'headLean',
normal:  {
normal:imgSrc.risk_normal.HEAD_LEAN
},
abnormal: {
normal:imgSrc.risk_abnormal.HEAD_LEAN
},
definition: '头部过度向前伸的现象。',
harm: {
bone: '椎弓变直或出现反弓',
muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
},
risks: [
{
name: '头晕头痛',
des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
},
{
name: '颈椎病',
des: '长期的重度头部前倾可能会导致颈椎病。'
},








]
}
],
shoulder: [
{
name: '高低肩',
key: 'highLowShoulder',
normal: {
left:imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
right:imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
normal:imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
},
abnormal: {
left:imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
right:imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
},
definition: '肩峰左右高度差超过2CM则为高低肩。',
harm: {
bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
neurovascular: '',
des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
},
risks: [
{
name: '慢性头痛',
des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
},
{
name: '骨刺',
des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
},
{
name: '腰痛',
des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
},
{
name: '长短腿',
des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
}
]
},
{
name: '圆肩',
key: 'roundShoulder',
normal:  {
normal:imgSrc.risk_normal.ROUND_SHOULDER
},
abnormal: {
normal:imgSrc.risk_abnormal.ROUND_SHOULDER
},
definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
harm: {
bone: '肩胛骨外展、胸廓变小',
muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
neurovascular: '',
des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
},
risks: [
{
name: '心脏负担加重',
des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
},
{
name: '头痛',
des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
},
{
name: '手臂麻木',
des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
}
]
}
],
trunk: [
{
name: '脊柱异位',
key: 'spineSidesway',
normal: {
left:imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
right:imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
normal:imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
},
abnormal:{
left:imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
right:imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
},
definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
harm: {
bone: '脊柱出现S型弯曲或C型弯曲',
muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
neurovascular: '',
des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
},
risks: [
{
name: '脊柱侧弯',
des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
},
{
name: '高低肩',
des: '脊柱侧弯可能伴随高低肩症状。'
},
{
name: '骨盆侧倾',
des: '脊柱侧弯可能伴随骨盆侧倾症状。'
}
]
}
],
pelvis: [
{
name: '骨盆侧倾',
key: 'pelvisLean',
normal: {
left:imgSrc.risk_normal.PELVIS_LEAN_LEFT,
right:imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
normal:imgSrc.risk_normal.PELVIS_LEAN_NORMAL
},
abnormal: {
left:imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
right:imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT,
},
definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
harm: {
bone: '骨盆倾斜',
muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
neurovascular: '',
des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
},
risks: [
{
name: '慢性疼痛',
des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
},
{
name: '腰椎间盘突出',
des: '骨盆侧倾可能加重腰椎间盘突出风险。'
},
{
name: '长短腿',
des: '骨盆侧倾可能加重长短腿风险。。'
}
]
}
],
'lower extremity': [
{
name: 'O型腿',
key: 'legO',
normal: {
normal:imgSrc.risk_normal.LEG_O
},
abnormal: {
normal:imgSrc.risk_abnormal.LEG_O
},
definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
harm: {
bone: 'O型腿（膝内翻）',
muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
neurovascular: '',
des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
},
risks: [
{
name: '半月板损伤',
des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
},
{
name: '关节炎',
des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' +
'置换手术。'
}
]
},
{
name: 'X型腿',
key: 'legX',
normal: {
normal:imgSrc.risk_normal.LEG_X
},
abnormal: {
normal:imgSrc.risk_abnormal.LEG_X
},
definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
harm: {
bone: 'X型腿（膝外翻）',
muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
neurovascular: '',
des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
},
risks: [
{
name: '半月板损伤',
des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
},
{
name: '关节炎',
des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' +
'置换手术。'
}
]
},
{
name: '膝过伸',
key: 'kneeOverstretch',
normal: {
normal:imgSrc.risk_normal.KNEE_OVERSTRETCH
},
abnormal: {
normal:imgSrc.risk_abnormal.KNEE_OVERSTRETCH
},
definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
harm: {
bone: '踝关节背屈不足，使膝关节无法向前移动',
muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
neurovascular: '',
des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
},
risks: [
{
name: '膝关节退变',
des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
},
{
name: '损害全身平衡',
des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
}
]
},
{
name: 'XO型腿',
key: 'legXO',
normal: {
normal:imgSrc.risk_normal.LEG_XO
},
abnormal:{
normal:imgSrc.risk_abnormal.LEG_XO
},
definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
harm: {
bone: '这个是XO型腿',
muscle: '这个是XO型腿',
neurovascular: '',
des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
},
risks: [
{
name: '膝关节疼痛',
des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
},
{
name: '膝关节炎',
des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
}
]
}
]
},
level: {
normal: 'normal',
mild: 'mild',
severe: 'severe'
},
risks: {},
points: null,
photos: null,
coverInfo: {},
modalInfo: null,
keyMap: {
face: {
headSidesway: {
position: ['neck', 'nose'],
scale: 0.5
},
highLowShoulder: {
position: ['shoulder-left', 'shoulder-right'],
scale: 0.3
},
spineSidesway: {
position: ['elbow-left', 'elbow-right'],
scale: 0.5
},
pelvisLean: {
position: ['hip-left', 'hip-right'],
scale: 1.5
},
legO: {
position: ['hip', 'ankle'],
scale: 0.3
},
legX: {
position: ['hip', 'ankle'],
scale: 0.3
},
legXO: {
position: ['hip', 'ankle'],
scale: 0.3
}
},
side: {
headLean: {
position: ['neck', 'ear'],
scale: 0.3
},
roundShoulder: {
position: ['nose', 'elbow'],
scale: 0
},
kneeOverstretch: {
position: ['hip', 'ankle'],
scale: 0.3
}
}
},
canvas: null,
img: {
face: null,
side: null
},
isWechat:false,
uuid:'',
type:'',
showMini:false,
drawFinish:{
face:false,
back:false,
side:false,
}
}
},
watch: {
locale: function() {

},
containerSwiper: function() {
this.containerSwiper != 0 ?  this.last_nav = true : ''
this.containerSwiper == 0 ?  this.last_nav = false : ''

if(this.isWechat){
if(this.containerSwiper == 3){
this.$refs.postureSwiper.swiper.allowSlideNext=false
}else{
this.$refs.postureSwiper.swiper.allowSlideNext=true;
}
}

sessionStorage.setItem('dis','-1' )
if(( this.isWechat) && this.containerSwiper != 0 ){
this.showMini = true;
}else{
this.showMini = false;
}

},

touchJump:function(){
if(this.touchJump ==true){

}
},
appopen:function(){

}
},
computed: {
swiper () {
return this.$refs.postureSwiper.swiper
}
},
methods: {
changeLang:function(lang){
console.log("lang",lang)
},
stop:function(){
this.$refs.Posture_bone.stop();
},
start:function(){
this.$refs.Posture_bone.start();
},
testClick(){
},
updateSwiperIndex(data) {
this.updateSwiper = data;
},
getRiskImg(risk){

let direction = 'normal';
let img;

if(!_.isNull( risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch'){
direction = risk.direction
}
if(this.checkIfAbnormal(risk.level)){
img = risk.abnormal[direction];
}else{
img = risk.normal[direction];
}
return img;
},
getSolutions(){

let _this = this;
if(this.isWechat){

wx.miniProgram.navigateTo({
url:`../solution/solution?uuid=${this.uuid}&type=${this.type}`,
success: function(){
_this.qrCode = false;
},
fail: function(){
_this.qrCode = true;
},
complete:function(){

}
});

}else{


this.qrCode = true
_this.appopen =true;
}
},
setModalInfo (risk) {
let that = this
this.modalInfo = risk
this.isUpdate = true;

this.$store.commit('updateUrl',risk.video)
this.setSymptomCanvasModal(risk)
this.$nextTick(function () {
that.$refs.riskModalRef.show()
let canvas = that.canvas

document.getElementById('modalBody').innerHTML = ''
document.getElementById('modalBody').appendChild(canvas)
})
},
setSymptomCanvasModal (risk) {
let points = this.points
let needDetail = ['legO', 'legX', 'legXO']
let forSide = ['headLean', 'roundShoulder', 'kneeOverstretch']

let riskKey = risk.key
let keyMap = this.keyMap
let positionArr
let positionPointsArr = []
let faceOrSide
let scale



Object.keys(keyMap).forEach(function (direction, index) {
Object.keys(keyMap[direction]).forEach(function (key, index) {
if (key === riskKey) {
positionArr = keyMap[direction][key].position
scale = keyMap[direction][key].scale
}
})
})



if (needDetail.indexOf(riskKey) !== -1) {

let lOrR
if (risk.detail === '右腿') {
lOrR = 'right'
} else {
lOrR = 'left'
}

for (let i = 0; i < positionArr.length; i++) {
positionPointsArr.push(points.face[positionArr[i]][lOrR])
}

faceOrSide = 'face'
}
else if (forSide.indexOf(riskKey) !== -1) {

let lOrR = this.conclusion.side.side

for (let i = 0; i < positionArr.length; i++) {

if (points.side[positionArr[i]].left === undefined) {

positionPointsArr.push(points.side[positionArr[i]])
} else {
positionPointsArr.push(points.side[positionArr[i]][lOrR])
}
}

faceOrSide = 'side'
}
else {

for (let i = 0; i < positionArr.length; i++) {
let positionAndDirectionArr = positionArr[i].split('-')
if (positionAndDirectionArr.length === 1) {
positionPointsArr.push(points.face[positionAndDirectionArr[0]])
} else {
positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]])
}
}

faceOrSide = 'face'
}



let _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x)
let _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y)
let xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2
let yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2

let width = _x > _y ? _x : _y
width *= (1 + scale)

let x = xMid - width / 2
let y = yMid - width / 2


let canvas = document.createElement('canvas')
let ctx = canvas.getContext('2d')
canvas.style.width = '100%'
canvas.style.height = '100%'
canvas.width = width
canvas.height = width



let img = this.img[faceOrSide]

ctx.drawImage(img, x, y, width, width, 0, 0, width, width)


this.canvas = canvas
},
drawBone(idx){
let data = this.reportData;

if(idx === 0){
if(this.drawFinish.face === false){
bone.drawFrontBone(data, document.getElementById('faceBone'));
this.drawFinish.face = true;
}


}else if(idx === 1){
if(this.drawFinish.side === false){
bone.drawSideBone(data, document.getElementById('sideBone'));
this.drawFinish.side = true;
}

}else if(idx === 2){
if(this.drawFinish.back === false){
bone.drawBackBone(data, document.getElementById('backBone'))
this.drawFinish.back = true;
}

}
},

shareWechatMini () {

wx.miniProgram.reLaunch({url: '../index/index'})
},
showDeleteButton(){
let that = this;
clearInterval(that.Loop);
that.Loop = setTimeout(function(){

},1000);
},

share(){
if(this.isWechat){
this.shelter = true

}else{

}
},
hideShelter(){
this.shelter = false
},
initSolutions(){},
setSymptomCanvas (option) {
let canvas = option.el
let ctx = canvas.getContext('2d')

let points = this.points
let needDetail = ['legO', 'legX', 'legXO']
let forSide = ['headLean', 'roundShoulder', 'kneeOverstretch']

let riskKey = canvas.dataset.key
let keyMap = this.keyMap
let positionArr
let positionPointsArr = []
let faceOrSide
let scale



Object.keys(keyMap).forEach(function (direction, index) {
Object.keys(keyMap[direction]).forEach(function (key, index) {
if (key === riskKey) {
positionArr = keyMap[direction][key].position
scale = keyMap[direction][key].scale
}
})
})



if (needDetail.indexOf(riskKey) !== -1) {

let lOrR
if (canvas.dataset.detail === '右腿') {
lOrR = 'right'
} else {
lOrR = 'left'
}

for (let i = 0; i < positionArr.length; i++) {
positionPointsArr.push(points.face[positionArr[i]][lOrR])
}

faceOrSide = 'face'
} else if (forSide.indexOf(riskKey) !== -1) {

let lOrR = this.conclusion.side.side

for (let i = 0; i < positionArr.length; i++) {

if (points.side[positionArr[i]].left === undefined) {

positionPointsArr.push(points.side[positionArr[i]])
} else {
positionPointsArr.push(points.side[positionArr[i]][lOrR])
}
}

faceOrSide = 'side'
} else {

for (let i = 0; i < positionArr.length; i++) {
let positionAndDirectionArr = positionArr[i].split('-')
if (positionAndDirectionArr.length === 1) {
positionPointsArr.push(points.face[positionAndDirectionArr[0]])
} else {
positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]])
}
}

faceOrSide = 'face'
}



let _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x)
let _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y)
let xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2
let yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2

let width = _x > _y ? _x : _y
width *= (1 + scale)

let x = xMid - width / 2
let y = yMid - width / 2


canvas.style.width = '100%'
canvas.style.height = '100%'
canvas.width = width
canvas.height = width
let img = new Image();
img.src = this.photos[faceOrSide];

img.onload=function(){
ctx.drawImage(img, x, y, width, width, 0, 0, width, width)
}

},
hideModal () {
this.$refs.riskModalRef.hide()
this.isUpdate = false;
},
hideSolutionsModal(){

},
getLevel (level) {
switch (level) {
case this.level.normal:
return {
des: '正常',
className: 'level-normal'
}
case this.level.mild:
return {
des: '潜在风险',
className: 'level-mild'
}
case this.level.severe:
return {
des: '高风险',
className: 'level-severe'
}
}
},
checkIfAbnormal(level) {
switch (level) {
case this.level.normal:
return false
case this.level.mild:
return false
case this.level.severe:
return true
}
},
sortHighToLow (arr) {
return _.orderBy(arr, ['value'], ['desc'])
},
slideIn (index) {
this.swiper.slideTo(index)
},
initRiskBar () {
this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0
let modalRiskBar = document.getElementById('modalRiskBar')
canvas.initRiskLevel({
el: modalRiskBar,
width: Number(modalRiskBar.parentNode.offsetWidth),
height: Number(modalRiskBar.parentNode.offsetHeight),
color: {
normal: '#00d963',
mild: '#ffbf00',
severe: '#ff4d4d'
},
level: this.level
})
},
initRisksData () {
let risks = this.risks
let level = this.level
let symptoms = this.symptoms
let normalRisks = []
let mildRisks = []
let severeRisks = []
for (let direction in risks) {
for (let i = 0; i < risks[direction].length; i++) {
let symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1]

if (symptom.value) {
let otherSymptom = Object.assign({}, symptom)
if (!risks[direction][i].valid) {
otherSymptom.raw = 0
otherSymptom.value = 0
otherSymptom.level = level.normal
otherSymptom.detail = ''
otherSymptom.direction = 'normal'
otherSymptom.cover = risks[direction][i]['cover']
otherSymptom.video = risks[direction][i]['video']
} else {
otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0
otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0
otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal
otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : ''
otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal'
otherSymptom.cover = risks[direction][i]['cover']
otherSymptom.video = risks[direction][i]['video']
}

symptoms[risks[direction][i].position].push(otherSymptom)
} else {
/*   symptom.video = risks[direction][i].video;
symptom.cover = risks[direction][i].cover; */
if (!risks[direction][i].valid) {
symptom.raw = 0
symptom.value = 0
symptom.level = level.normal
symptom.detail = ''
symptom.direction = 'normal'
symptom.cover = risks[direction][i]['cover']
symptom.video = risks[direction][i]['video']
} else {
symptom.cover = risks[direction][i]['cover']
symptom.video = risks[direction][i]['video']
symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0
symptom.value = risks[direction][i].value ? risks[direction][i].value : 0
symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal
symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : ''
symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal'
}

}
}
}

for (let position in symptoms) {
for (let i = 0; i < symptoms[position].length; i++) {
if (_.isUndefined(symptoms[position][i].value)) {
continue
}
switch (symptoms[position][i].level) {
case level.normal:
normalRisks.push(symptoms[position][i])
break
case level.mild:
mildRisks.push(symptoms[position][i])
break
case level.severe:
severeRisks.push(symptoms[position][i])
break
default:
normalRisks.push(symptoms[position][i])
break
}
}
}

this.normalRisks = this.sortHighToLow(normalRisks)
this.mildRisks = this.sortHighToLow(mildRisks)
this.severeRisks = this.sortHighToLow(severeRisks)
},
initRiskPoints () {
let that = this
let points = this.points
let photos = this.photos
let faceCanvas = document.createElement('canvas')
let sideCanvas = document.createElement('canvas')
let _this = this


let facePointsArr = []
let face = points.face
let faceImg = new Image()




let hipRPoint = face['hip']['right']
let hipLPoint = face['hip']['left']
let neckPoint = face['neck']
let hipMPoint = {
x: 0,
y: 0
}
let hipAndNeckMPoint = {
x: 0,
y: 0
}
if ((hipLPoint.x === 0 && hipLPoint.y === 0) || (hipRPoint.x === 0 && hipRPoint.y === 0)) {

} else {

hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2
hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2


if (!(neckPoint.x === 0 && neckPoint.y === 0)) {
hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2
hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2
}
};

face.hipM = hipMPoint
face.hipAndNeckM = hipAndNeckMPoint

let faceOrder = [
['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'],
['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'],

['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'],
['neck', 'hipAndNeckM', 'hipM'],
['nose', 'neck']
]


let verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left']
let verticalPointsArr = []


let risks = this.normalRisks.concat(this.mildRisks, this.severeRisks)


let faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee']
let faceHorizontalArr = []






faceImg.src = photos.face
faceImg.onload = function () {
that.img.face = faceImg

}


let side = points.side
let sidePointsArr = []
let sideImg = new Image()



sideImg.src = photos.side
sideImg.onload = function () {
that.img.side = sideImg



}
},
initBone () {
let data = this.reportData;
this.$nextTick(function () {
bone.drawFrontBone(data, document.getElementById('faceBone'));
bone.drawSideBone(data, document.getElementById('sideBone'));
bone.drawBackBone(data, document.getElementById('backBone'))


})
},
drawPoint (option) {
let canvas = option.el
let point = option.point
let cxt = canvas.getContext('2d')
cxt.save()
cxt.fillStyle = '#009eff'
cxt.beginPath()
cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI)
cxt.closePath()
cxt.fill()
cxt.restore()
cxt.save()
cxt.fillStyle = 'rgba(83, 158, 255, .3)'
cxt.beginPath()
cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI)
cxt.closePath()
cxt.fill()
cxt.restore()
},
drawLine (option) {


if ((option.points[0].x === 0 && option.points[0].y === 0) || (option.points[1].x === 0 && option.points[1].y === 0)) {
return
}
let canvas = option.el
let points = option.points
let cxt = canvas.getContext('2d')
cxt.save()
cxt.lineWidth = 3
if (!option.isSide) {
cxt.strokeStyle = '#5f58f4'
cxt.beginPath()
cxt.moveTo(points[0].x, points[0].y)
cxt.lineTo(points[1].x, points[1].y)
cxt.closePath()
cxt.stroke()
} else {
let _x = Math.abs(points[0].x - points[1].x)
let _y = Math.abs(points[0].y - points[1].y)
let z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2))
let startX
let startY
let endX
let endY
let distance = 80


if (points[0].x > points[1].x) {
startX = Math.round(points[1].x - distance * _x / z)
startY = Math.round(points[1].y + distance * _y / z)
endX = Math.round(points[0].x + distance * _x / z)
endY = Math.round(points[0].y - distance * _y / z)
} else {
startX = Math.round(points[0].x - distance * _x / z)
startY = Math.round(points[0].y - distance * _y / z)
endX = Math.round(points[1].x + distance * _x / z)
endY = Math.round(points[1].y + distance * _y / z)
}

cxt.strokeStyle = '#0ef8cd'
cxt.beginPath()
cxt.moveTo(startX, startY)
cxt.lineTo(endX, endY)
cxt.closePath()
cxt.stroke()
}

cxt.restore()
},
drawRectAndAngle (option) {
let cxt = option.cxt
let angle = option.angle
let point = option.point

cxt.save()
if (option.isSecond) {
cxt.translate(0, 43)
}
cxt.save()
cxt.fillStyle = 'rgba(100, 100, 98, 0.5)'
cxt.beginPath()
cxt.moveTo(point.x + 13, point.y + 3)
cxt.lineTo(point.x + 99, point.y + 3)
cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13)
cxt.lineTo(point.x + 109, point.y + 33)
cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43)
cxt.lineTo(point.x + 13, point.y + 43)
cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33)
cxt.lineTo(point.x + 3, point.y + 13)
cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3)
cxt.closePath()
cxt.fill()
cxt.restore()


cxt.save()
cxt.font = '34px Arial'
cxt.fillStyle = '#0cfcca'
cxt.textAlign = 'center'
if (option.isTrunk) {
cxt.fillText(`${angle}%`, point.x + 56, point.y + 38)
} else {
cxt.fillText(`${angle}°`, point.x + 56, point.y + 38)
}
cxt.restore()
cxt.restore()
},
drawLineAndAngle (option) {
let canvas = option.el
let width = canvas.width
let points = option.points
let min = option.min - 100
let max = option.max + 100
let cxt = canvas.getContext('2d')


for (let i = 0; i < points.length; i++) {
if (points[i].x === 0 && points[i].y === 0) {
return
}
}



if (points.length === 1) {
this.drawRectAndAngle({
cxt: cxt,
angle: (option.angle * 100).toFixed(1),
point: {
x: width - 120,
y: points[0].y
},
isSecond: false,
isTrunk: true
})
} else {
let _x = Math.abs(points[0].x - points[1].x)
let _y = Math.abs(points[0].y - points[1].y)
let startPoint = {}
let endPoint = {}
let offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0))
let offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0))

if (points[0].y < points[1].y) {
startPoint.x = min
startPoint.y = points[0].y - offsetYL
endPoint.x = max
endPoint.y = points[1].y + offsetYR
} else {
startPoint.x = min
startPoint.y = points[0].y + offsetYL
endPoint.x = max
endPoint.y = points[1].y - offsetYR
}

cxt.save()
cxt.strokeStyle = '#14bc9a'
cxt.beginPath()
cxt.moveTo(startPoint.x, startPoint.y)
cxt.lineTo(endPoint.x, endPoint.y)
cxt.closePath()
cxt.stroke()
cxt.restore()


this.drawRectAndAngle({
cxt: cxt,
angle: option.angle.toFixed(1),
point: {
x: width - 120,
y: points[1].y
},
isSecond: false
})

if (!_.isUndefined(option.secondAngle)) {
this.drawRectAndAngle({
cxt: cxt,
angle: option.secondAngle.toFixed(1),
point: {
x: width - 120,
y: points[1].y
},
isSecond: true
})
}
}
},
...mapState({
initReportData (state) {
let reportData = state.vux.reportData
let _this = this

if (_.isNull(reportData)) {
let uuid = ''
let type = ''

let urlquery = url.parse(window.location.href).query
let query = urlquery.split('&')
for (let every = 0; every < query.length; every++) {
if (query[every].indexOf('uuid=') !== -1) {
uuid = query[every].replace('uuid=', '')
}
if (query[every].indexOf('type=') !== -1) {
type = query[every].replace('type=', '')
}
}
this.uuid = uuid;
this.type = type;
console.log({
url: `v1/posture/reports/${uuid}`,
language: this.$i18n.locale
})
var language = this.$i18n.locale;
this.get({
url: `v1/posture/reports/${uuid}`,
params: {
type: type,
language: language,
},
success (result) {
_this.updateReportData({
reportData: result
})
_this.getReportData()

},
error (data) {
_this.loading = false
_this.valid = false
}
})
} else {
_this.getReportData()
}
},
getReportData (state) {
this.loading = false;
let reportData = state.vux.reportData;
let that = this;
wx.miniProgram.getEnv(res => {


if (res.miniprogram) {
that.isWechat = true;
} else {
that.isWechat = false;
}

});

this.qrImage = reportData.solutions

let customer = reportData.customer
let header = reportData.header
let user = reportData.user
let coverInfo = {}
if (_.isNull(header)) {
coverInfo.date = '--'
coverInfo.time = '--'
} else {
coverInfo.date = moment(header.creationTime).format('YYYY-MM-DD')
coverInfo.time = moment(header.creationTime).format('hh:mm')
}

if (_.isNull(user)) {
coverInfo.userName = '--'
} else {
coverInfo.userName = user.name
}

if (_.isNull(customer)) {
coverInfo.customerName = '--'
} else {
coverInfo.customerName = customer.name
}

if(_.isNull(header)) {
coverInfo.logo = ''
} else {
coverInfo.logo = header.logo
}
this.coverInfo = coverInfo


this.conclusion = reportData.conclusion
let conclusion = this.conclusion
if (!conclusion.face.valid || !conclusion.side.valid) {
this.valid = false
} else {
this.risks = {
face: conclusion.face.risks,
side: conclusion.side.risks
}
this.initRisksData()
this.$nextTick(function () {
let riskBodys = document.getElementsByClassName('risk-body')
for(let i = 0; i < riskBodys.length; i++){
this.setSymptomCanvas({
el: riskBodys[i],
width: Number(riskBodys[i].parentNode.offsetWidth),
height: Number(riskBodys[i].parentNode.offsetHeight),
})

}
let riskBars = document.getElementsByClassName('risk-bar')
for (let i = 0; i < riskBars.length; i++) {
canvas.initRiskLevel({
el: riskBars[i],
width: Number(riskBars[i].parentNode.offsetWidth),
height: Number(riskBars[i].parentNode.offsetHeight),
color: {
normal: '#00d963',
mild: '#ffbf00',
severe: '#ff4d4d'
},
level: this.level
})
}

})
}


let points = {
face: conclusion.face.points,
side: Object.assign(conclusion.side.points, {side: conclusion.side.side})
}
this.points = points



let photos = {
face: reportData.face,
side: reportData.side
}
this.photos = photos
this.reportData = reportData
this.initRiskPoints();

}
}),
GetQueryString(name) {
var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
var r = window.location.search.substr(1).match(reg);
if(r!=null)return  unescape(r[2]); return null;
},
...mapActions(['get']),
...mapMutations(['updateReportData'])
},
created () {
this.initReportData()
var _this = this
for (var i = 0; i < bullets.length; i++) {

bullets[i].text = this.bullets[i].text
}
for (var i = 0; i < viwesNav.length; i++) {
viwesNav[i].text = this.viwesNav[i].text
}
var symptoms = this.symptoms
_this.symptoms = Object.assign({} , _this.$t('symptoms'))
if (this.GetQueryString("muscle") == 'hide') {
this.MuscleShow = false
} else {
this.MuscleShow = true
}
},
mounted () {
console.log('bullets:', this.bullets, this.$tc('bullets', 0), )
}
}



// WEBPACK FOOTER //
// ./src/components/Posture.vue